<template>
    <section class="content">
        <div class="row">
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">{{'client' | translate}}:</h3>
                        <div class="box-tools pull-right">
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="box-body">
                        <div class="row pb-10">
                            <div class="col-sm-8">
                                <h5>{{order.customer_firstname}} {{order.customer_name}}</h5>
                                <p class="small text-muted"><i class="fa fa-envelope mr-5"></i><a :href="'mailto:' + order.customer_email">{{order.customer_email}}</a><br><i class="fa fa-phone mr-5"></i><a :href="'tel:' + order.customer_tel">{{order.customer_tel}}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="box box-primary">
                    <div class="box-header no-border">
                        <h3 class="box-title">Zusatzinformationen</h3>
                        <div class="box-tools pull-right">
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="box-body" style="padding-top: 2px; padding-bottom: 0px;">
                        <ul class="list-group list-group-unbordered">
                            <li class="list-group-item">
                                <b>Reservierungsnummer:</b> <span class="pull-right"> {{order.reservation_id}}</span>
                            </li>
                            <li class="list-group-item">
                                <b>Reservierungsdatum:</b> <span class="pull-right">{{order.date_order | orderDate}} / <i class="fa fa-clock-o mr-5"></i>{{order.date_order | orderDate(true)}}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{'handler' | translate}}:</b> <span class="pull-right">{{order.store_information}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Reservierte Produkte</h3>
                        <div class="box-tools pull-right">
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class=" box-controls">
                        <div class="table-responsive">
                            <table class="table no-margin">
                                <thead>
                                <tr>
                                    <th>{{'reservation_nr' | translate}}</th>
                                    <th>{{'date' | translate}}</th>
                                    <th>{{'client' | translate}}</th>
                                    <th>Anzahl Artikel</th>
                                    <th>{{'total_price' | translate}}</th>
                                    <th>{{'handler' | translate}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{order.reservation_id}}</td>
                                    <td>{{order.date_order | orderDate}}<br><small class="text-muted">{{order.date_order | orderDate(true)}}</small></td>
                                    <td>{{order.customer_firstname}}  {{order.customer_name}}</td>
                                    <td>1</td>
                                    <td>{{order.products_price | currency}}</td>
                                    <td>{{order.store_information}}<br><small class="text-muted">{{order.store_number}}</small></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr>
                        <p><strong><i class="fa fa-comment mr-5"></i>Kommentar zur Reservierung:</strong></p>
                        <p class="small mb-10" v-if="order.customer_comment === ''">Es wurde kein Kommentar zur Reservierung hinterlegt!</p>
                        <p class="small mb-10" v-else>
                           {{order.customer_comment}}
                        </p>
                    </div>
                    <div class="box-body">
                        <div class="table-responsive">
                            <table class="table table-hover" style="margin-top:30px;">
                                <thead>
                                <tr>
                                    <th>Status</th>
                                    <th>{{'image' | translate}}</th>
                                    <th>{{'item' | translate}}</th>
                                    <th>{{'size' | translate}}</th>
                                    <th>{{'color' | translate}}</th>
                                    <th>{{'unit_price' | translate}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td colspan="12"><i class="fa fa-angle-double-down mr-5"></i><small>{{'sold_through' | translate}}:</small><small class="text-success ml-5">{{order.store_number}} - {{order.store_information}} - {{order.contact_email}}</small></td>
                                </tr>
                                <tr>
                                    <td><span :class="order.status.style"><i :class="order.status.icon"></i>{{order.status.label}}</span></td>
                                    <td>
                                        <img :src="order.products_image" class="img-preview">
                                    </td>
                                    <td># {{order.products_id}}</td>
                                    <td>{{order.products_size}}</td>
                                    <td>{{order.products_color}}</td>
                                    <td>{{order.products_price | currency}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-4">
                <div :class="['box box-primary direct-chat', order.histories.length === 0 ? 'collapsed-box' : '']">
                    <div class="box-header with-border">
                        <h3 class="box-title"><i class="fa fa-clock-o mr-5"></i>Historie</h3>
                        <div class="box-tools pull-right">
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i :class="[order.histories.length === 0 ? 'fa fa-plus' : 'fa fa-minus']"></i></button>
                        </div>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <!-- Conversations are loaded here -->
                        <div class="direct-chat-messages">
                            <ul class="list-group list-group-unbordered">
                                <li class="list-group-item" v-for="h in order.histories">
                                    <p><strong>{{h.date | orderDate}}</strong><span class="text-muted small ml-5"><i class="fa fa-clock-o"></i> {{h.date | orderDate(true)}}</span><br>
                                        <span :class="h.status.style.replace('label label-', 'text-')"><i :class="h.status.icon"></i>{{h.status.label}}</span></p>
                                </li>
                            </ul>
                        </div>
                        <!--/.direct-chat-messages-->
                    </div>
                    <!-- /.box-body -->
                    <div class="box-footer"></div>
                </div>
            </div>
            <div class="col-md-4 col-sm-12">
                <!-- DIRECT CHAT PRIMARY -->
                <div :class="['box box-primary direct-chat', order.contacts.length === 0 ? 'collapsed-box' : '']">
                    <div class="box-header with-border">
                        <h3 class="box-title">{{'merchant_communication' | translate}}</h3>
                        <div class="box-tools pull-right">
                            <span data-toggle="tooltip" title="3 Bearbeitungen" class="badge bg-success">{{order.contacts.length}}</span>
                            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i :class="[order.contacts.length === 0 ? 'fa fa-plus' : 'fa fa-minus']"></i></button>
                        </div>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <!-- Conversations are loaded here -->
                        <div class="direct-chat-messages">
                            <template v-for="c in order.contacts">
                                <template v-if="c.author === 'merchant'">
                                    <div  class="direct-chat-msg">
                                    <div class="direct-chat-info clearfix">
                                        <span class="direct-chat-name pull-left">{{c.author}}</span>
                                        <span class="direct-chat-timestamp pull-right">{{c.date | orderDate}} <i class="fa fa-clock-o mr-5 ml-5"></i>{{c.date | orderDate(true)}}</span>
                                    </div>
                                    <img class="direct-chat-img" src="/static/img/user2-160x160.jpg" alt="Message User Image">
                                    <div class="direct-chat-text"><template v-for="line in c.message">{{line}}<br/></template></div>
                                </div>
                                </template>
                                <template v-else>
                                    <div  class="direct-chat-msg right">
                                        <div class="direct-chat-info clearfix">
                                            <span class="direct-chat-name pull-left">{{c.author}}</span>
                                            <span class="direct-chat-timestamp pull-right">{{c.date | orderDate}} <i class="fa fa-clock-o mr-5 ml-5"></i>{{c.date | orderDate(true)}}</span>
                                        </div>
                                        <img class="direct-chat-img" src="/static/img/user2-160x160.jpg" alt="Message User Image">
                                        <div class="direct-chat-text bg-info"><template v-for="line in c.message">{{line}}<br/></template></div>
                                    </div>
                                </template>
                            </template>
                        </div>
                        <!--/.direct-chat-messages-->
                    </div>
                    <!-- /.box-body -->
                </div>
                <!--/.direct-chat -->
            </div>
            <div class="col-md-4 col-sm-12">
                <reservation-notes :id="$route.params.id" :notes="order.notes"></reservation-notes>
            </div>
        </div>
    </section>
</template>
<script>
import ReservationNotes from "../tools/ReservationNotes";
export default {
	components: {ReservationNotes},
	data () {
    return {
      order: {}
    }
  },
  methods: {
    getStatus (label, id) {
      if (id === 1 || id === 2 || id === 5 || id === 6) {
        return {label: label, style: 'label label-success', icon: 'fa fa-check mr-5'}
      } else if (id === 7) {
        return {label: label, style: 'label label-info', icon: 'fa fa-check-circle mr-5'}
      } else {
        return {label: label, style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      }
    },
    getData () {
      API.get(`clickAndCollect/${this.$route.params.id}`)
        .then(res => {
          this.order = res.data
          this.order.date_order = this.order.date_order.split(' ')
          this.order.date_order[0] = this.order.date_order[0].split('-').reverse().join('.')
          this.order.date_order = this.order.date_order.join(' ')
          this.order.status = this.getStatus(this.order.status, this.order.status_id)
	        this.order.notes.forEach(o => {
		        o.message = o.message.split('\n')
		        o.date = o.date.split(' ')
		        o.date[0] = o.date[0].split('-').reverse().join('.')
		        o.date = o.date.join(' ')
	        })
	        this.order.histories.forEach(o => {
		        o.status = this.getStatus(o.status, o.status_id)
		        o.date = o.date.split(' ')
		        o.date[0] = o.date[0].split('-').reverse().join('.')
		        o.date = o.date.join(' ')
	        })
          this.order.contacts.forEach(c => {
	          c.message = c.message.split('\n')
          	c.date = c.date.split(' ')
            c.date[0] = c.date[0].split('-').reverse().join('.')
            c.date = c.date.join(' ')
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
      this.getData()
    }
  },
  watch: {
    '$route.params.id' () {
      this.notFound = false
      this.getData()
    }
  }
}
</script>
<style>
    .special {
        font-size: 0.975rem;
        font-weight: bold;
    }
    .overlay {
        z-index: 50;
        background: rgba(33,34,40,.75);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 110%;
    }
    .overlay-text{
        position: absolute;
        top: 54%;
        left: 49%;
        margin-left: -1rem;
        margin-top: -1rem;
    }
    .overlay > .fa {
        position: absolute;
        top: 50%;
        left: 57%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: currentColor;
        font-size: 2rem;
        opacity: 0.65;
    }
    select option.danger {
        margin: 40px;
        background:rgb(86, 32, 27);
        color: #fff;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
    }
    select option.normal {
        margin: 40px;
        background:rgb(32, 34, 39);
        color: #fff;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
    }
    select option.warning {
        margin: 40px;
        background:#5e4219;
        color: #fff;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
    }
</style>
<style scoped>
    .loading-gif {
        display: block;
        width: 5%;
        top: 42%;
        left: 50%;
        position: fixed;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/SingleClickCollect.vue